<nlr-tabset>
    @if ((['EDIT_INFORMATION', 'VIEW_INFORMATION'] | hasPermissions)) {
        <nlr-tab
            [id]="TABS.INFORMATION"
            title="Information"
            active="true">
        </nlr-tab>
    }

    @if (isAnalysisTabEnabled() && (['EDIT_ANALYSIS', 'VIEW_ANALYSIS'] | hasPermissions)) {
        <nlr-tab
            [id]="TABS.ANALYSIS"
            [preventSelection]="preventAnalysisTabSelection"
            title="Analysis">
        </nlr-tab>
    }

    @if (isInterestsTabEnabled() && (['EDIT_INTERESTS', 'VIEW_INTERESTS'] | hasPermissions)) {
        <nlr-tab
            [id]="TABS.INTERESTS"
            title="Interests">
        </nlr-tab>
    }

    @if (isDesignTabEnabled() && (['EDIT_DESIGN', 'VIEW_DESIGN'] | hasPermissions)) {
        <nlr-tab
            [id]="TABS.DESIGN"
            title="Design">
        </nlr-tab>
    }

    @if (isDigitalPlanTabEnabled()) {
        <nlr-tab
            [id]="TABS.DIGITAL_PLAN"
            title="Digital Plan">
        </nlr-tab>
    }

    @if (isCertificationTabEnabled() && (['EDIT_CERTIFICATION', 'VIEW_CERTIFICATION'] | hasPermissions)) {
        <nlr-tab
            [id]="TABS.CERTIFICATION"
            title="Certification">
        </nlr-tab>
    }

    @if (isLodgeTabEnabled() && (['EDIT_LODGE', 'VIEW_LODGE'] | hasPermissions)) {
        <nlr-tab
            [id]="TABS.LODGE"
            title="Lodge">
        </nlr-tab>
    }

    @if (hasAdditionalsPermission()) {
        <nlr-tab
            [id]="TABS.ADDITIONALS"
            title="Additionals">
        </nlr-tab>
    }
</nlr-tabset>
<div class="summary">
    <table class="details table-no-borders">
        <tr>
            <td
                ><span
                    class="boldText"
                    title="The main land tenure for the plan"
                    >Tenure type</span
                ></td
            >
            <td
                ><span>{{getModel().tenureType ? getModel().tenureType.name : ""}}</span></td
            >
        </tr>
        <tr>
            <td
                ><span
                    class="boldText"
                    title="The type of plan being created"
                    >Plan type</span
                ></td
            >
            <td
                ><span>{{getModel().planType? getModel().planType.name: ""}}</span></td
            >
        </tr>
        <tr>
            <td
                ><span
                    class="boldText"
                    title="The unique identifier of the plan"
                    >Plan number</span
                ></td
            >
            <td
                ><span>{{getModel().planNumber}}</span></td
            >
        </tr>
        <tr>
            <td
                ><span
                    class="boldText"
                    title="The reason for, or intent of plan"
                    >Plan purpose</span
                ></td
            >
            <td
                ><span>{{getModel().planPurpose? getModel().planPurpose.name: ""}}</span></td
            >
        </tr>
        <tr>
            <td
                ><span
                    class="boldText"
                    title="The version number of the plan"
                    >Version</span
                ></td
            >
            <td
                ><span class="badge">{{getModel().versionNumber}}</span></td
            >
        </tr>
        <tr>
            <td
                ><span
                    class="boldText"
                    title="The status of the plan"
                    >Plan status</span
                ></td
            >
            <td
                ><span>{{getLodgementStageDescription(getModel().planLodgementStage)}}</span></td
            >
        </tr>
        <tr>
            <td
                ><span
                    class="boldText"
                    title="The method used to create the plan pdf"
                    >PDF created using</span
                ></td
            >
            <td
                ><span>{{PDF_CREATION_METHOD_DESCRIPTION[getModel().pdfCreationMethod]}}</span></td
            >
        </tr>
    </table>
    <validation-results
        [isAnalysisTabEnabled]="propIsAnalysisTabEnabled"
        [isDesignTabEnabled]="propIsDesignTabEnabled"
        [isInterestsTabEnabled]="propIsInterestsTabEnabled"
        [isCertificationTabEnabled]="propIsCertificationTabEnabled"></validation-results>
</div>
